<app-gloss-input [options]="passwordInputOptions">
  <icon
    [name]="passwordVisible ? 'eye' : 'eye-off'"
    [size]="6"
    (click)="togglePasswordVisibility()"
    class="tw-cursor-pointer tw-opacity-60"
  ></icon>
</app-gloss-input>
